import React, { useState, useEffect } from 'react';

import './more-like-this-widget.m.css';
import CardImage from '../../atoms/cardimage';

const MoreLikeThisWidget = (props) => {
  const [allStories, setAllStories] = useState([]);

  useEffect(() => {
    if (allStories.length === 0) {
      (async () => {
        const storyId = props.story.id;
        const response = await (
          await fetch(`/api/v1/stories/${storyId}/related-stories?limit=5`)
        ).json();
        setAllStories(response['related-stories']);
      })();
    }
  }, []);

  return (
    <React.Fragment>
      {allStories?.length > 0 && (
        <div styleName="more-like-this-wrapper">
          <div styleName="more-like-this-heading">
            <img src="/images/red-lines.svg" alt="red-lines" />
            <h4 styleName="heading">MORE LIKE THIS</h4>
            <img src="/images/red-lines.svg" alt="red-lines" />
          </div>
          <div styleName="section">
            {allStories.map((story, index) => (
              <div styleName="story" key={index}>
                <a href={`/${story.slug}`} styleName="item">
                  <div styleName="image-container">
                    <CardImage
                      story={story}
                      aspectRatio={[1, 1]}
                      imageType="image1x1"
                      showHeroDetails={false}
                      isLazy={true}
                    />
                  </div>
                  <h5 styleName="text">{story.headline}</h5>
                </a>
              </div>
            ))}
          </div>
        </div>
      )}
    </React.Fragment>
  );
};

export default MoreLikeThisWidget;
